import type { BadgeVariantProps } from "@/ui2/atoms/Badge";
import type { CosignatureStatus } from "@/core/types";

export const CosignatureTabEnum = {
  ALL_NOTES: "all-notes",
  NEEDS_REVIEW: "needs-review",
} as const;

export const ALL_OPTION_ID = "all";

type StatusVariant = Pick<BadgeVariantProps, "appearance" | "variant">;

export const STATUS_VARIANT: Record<CosignatureStatus, StatusVariant> = {
  pending: { appearance: "outline", variant: "neutral" },
  rejected: { appearance: "outline", variant: "error" },
  resubmitted: { appearance: "outline", variant: "warning" },
  signed: { appearance: "outline", variant: "success" },
} as const;

export const QUEUE_ROW_COUNT = 10;
